module.exports = __webpack_public_path__ + "img/bella-art.6147ebb5.jpg";